import{m as e}from"./chunk-HBP5N4FR.js";e();var o=`.dapp-core-component__signStepBodyStyles__summary {
  display: flex;
  flex-direction: column;
  margin: auto;
}
.dapp-core-component__signStepBodyStyles__summary .dapp-core-component__signStepBodyStyles__fields {
  gap: 32px;
  display: flex;
  flex-direction: column;
}
.dapp-core-component__signStepBodyStyles__summary .dapp-core-component__signStepBodyStyles__fields .dapp-core-component__signStepBodyStyles__columns {
  display: flex;
  column-gap: 16px;
  row-gap: 32px;
  flex-wrap: wrap;
  align-items: flex-start;
}
.dapp-core-component__signStepBodyStyles__summary .dapp-core-component__signStepBodyStyles__fields .dapp-core-component__signStepBodyStyles__columns .dapp-core-component__signStepBodyStyles__column {
  min-width: calc(50% - 8px);
  text-align: left;
}
.dapp-core-component__signStepBodyStyles__summary .dapp-core-component__signStepBodyStyles__buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 72px;
}
@media (min-width: 768px) {
  .dapp-core-component__signStepBodyStyles__summary .dapp-core-component__signStepBodyStyles__buttons {
    margin-top: 80px;
  }
}`;document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(o));var _={summary:"dapp-core-component__signStepBodyStyles__summary",fields:"dapp-core-component__signStepBodyStyles__fields",columns:"dapp-core-component__signStepBodyStyles__columns",column:"dapp-core-component__signStepBodyStyles__column",buttons:"dapp-core-component__signStepBodyStyles__buttons"};export{o as a,_ as b};
//# sourceMappingURL=chunk-3FZX37WC.js.map
